__turbopack_context__.v({
  "copyright": "style-module__AMuLbq__copyright",
  "feature": "style-module__AMuLbq__feature",
  "footer": "style-module__AMuLbq__footer",
  "icon": "style-module__AMuLbq__icon",
  "inner": "style-module__AMuLbq__inner",
  "instagram": "style-module__AMuLbq__instagram",
  "row": "style-module__AMuLbq__row",
  "social": "style-module__AMuLbq__social",
  "whatsapp": "style-module__AMuLbq__whatsapp",
  "youtube": "style-module__AMuLbq__youtube",
});
